import { render, staticRenderFns } from "./RTEAddImageIcon.vue?vue&type=template&id=6c793e8c&scoped=true"
import script from "./RTEAddImageIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./RTEAddImageIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c793e8c",
  null
  
)

export default component.exports